export const mockData = {
  psychologist: {
    name: "Rafaela",
    title: "Psicóloga Clínica",
    crp: "CRP 08/45852",
    onlineService: "Atendimento online em todo Brasil!",
    greeting: "Mesmo quando parece confuso, há um sentido por trás do que você sente.",
    description: ""
  },

  approach: {
    name: "TCC - Terapia Cognitivo-Comportamental",
    description: "Utilizo a TCC, uma abordagem terapêutica estruturada e baseada em evidências científicas que se concentra na relação entre pensamentos, sentimentos e comportamentos. É uma das formas de psicoterapia mais pesquisadas e eficazes disponíveis atualmente.",
    
    benefits: [
      {
        title: "Abordagem Científica",
        description: "Trabalho com técnicas baseadas em pesquisas e evidências científicas, oferecendo métodos comprovadamente eficazes para diversos transtornos psicológicos."
      },
      {
        title: "Foco no Presente",
        description: "Me concentro nos seus problemas atuais e nas soluções práticas, trabalhando com situações do seu dia a dia e desafios contemporâneos."
      },
      {
        title: "Técnicas Práticas",
        description: "Utilizo ferramentas concretas como reestruturação cognitiva, exposição gradual e treino de habilidades sociais."
      },
      {
        title: "Objetivos Claros",
        description: "Trabalho com você definindo metas específicas e mensuráveis, permitindo acompanhar seu progresso terapêutico de forma objetiva."
      }
    ],

    howItWorks: "Através da TCC, ajudo você a identificar padrões de pensamento negativos ou distorcidos e comportamentos disfuncionais, ensinando estratégias para modificá-los. Trabalho em colaboração contigo para desenvolver habilidades de enfrentamento e promover mudanças duradouras."
  },

  services: [
    {
      title: "Atendimento Online",
      description: "Ofereço sessões via videoconferência para todo o Brasil, com a mesma qualidade do atendimento presencial."
    },
    {
      title: "Sessões de 1 hora",
      description: "Cada sessão tem duração de 60 minutos, tempo adequado para um trabalho terapêutico efetivo."
    },
    {
      title: "Sigilo Profissional",
      description: "Todos os meus atendimentos seguem rigorosamente o código de ética profissional da psicologia."
    }
  ],

  ethics: {
    title: "Código de Ética e Sigilo",
    description: "Código de Ética é um conjunto de regras e princípios que orientam a conduta profissional dos psicólogos. É como um manual que estabelece o que pode e não pode ser feito durante o atendimento psicológico. O sigilo profissional é uma das principais regras deste código, garantindo que todas as informações compartilhadas durante as sessões sejam mantidas em absoluta confidencialidade. Isso significa que nada do que for dito pode ser revelado a terceiros, criando um ambiente seguro e protegido para o paciente se expressar sem medo de julgamentos ou exposição."
  },

  contact: {
    whatsapp: "41 991926668",
    whatsappMessage: "Olá! Tudo bem? Vim através do seu site e gostaria de mais informações sobre a psicoterapia.",
    instagram: "psi_raffa",
    location: "Atendimento Online - Todo o Brasil"
  },

  finalMessage: {
    quote: "Toda dor merece seu espaço para ser ouvida.",
    signature: "Te espero!"
  }
};